import React, { useState } from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import { motion } from "framer-motion";
import { FiMail } from "react-icons/fi";
import backgroundImg from "../assets/login.webp";
//import { useForgotPasswordMutation } from "../store/apis/authApi"; // ✅ assumes you have an API endpoint

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  // const [forgotPassword] = useForgotPasswordMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    if (!email) {
      setError("Please enter your email address.");
      setLoading(false);
      return;
    }

    console.log('Successfuly login')

    // try {
    //   const response = await forgotPassword({ email }).unwrap();
    //   if (response.status === "success") {
    //     setSuccess("We’ve sent a reset link to your email.");
    //   }
    // } catch (err) {
    //   setError(
    //     err?.data?.message || "Could not send reset link. Please try again."
    //   );
    // } finally {
    //   setLoading(false);
    // }
  };

  return (
    <PageContainer>
      <Helmet>
        <title>Forgot Password | SolarAIDD</title>
        <meta name="description" content="Reset your SolarAIDD account password securely." />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href="https://solaraidd.csir.co.za/forgot-password" />
      </Helmet>

      <Card
        as={motion.div}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <h2>Forgot Password</h2>
        <p>Enter your email and we’ll send you a reset link.</p>

        <Form onSubmit={handleSubmit}>
          {error && <Error>{error}</Error>}
          {success && <Success>{success}</Success>}

          <InputWrapper>
            <FiMail />
            <Input
              type="email"
              placeholder="Your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </InputWrapper>

          <Button type="submit" disabled={loading}>
            {loading ? <span className="spinner" /> : "Send Reset Link"}
          </Button>
        </Form>

        <BackLink href="/login">← Back to Login</BackLink>
      </Card>
    </PageContainer>
  );
};

export default ForgotPassword;

// 🔹 Styled Components
const PageContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),
    url(${backgroundImg});
  background-size: cover;
  background-position: center;
  justify-content: center;
  align-items: center;
`;

const Card = styled.div`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(12px);
  padding: 2.5rem;
  border-radius: 20px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  text-align: center;
  max-width: 400px;
  width: 100%;
  color: white;

  h2 {
    margin-bottom: 0.5rem;
    font-size: 2rem;
  }
  p {
    font-size: 0.9rem;
    margin-bottom: 1.5rem;
    color: #f0f0f0;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  padding: 0.8rem 1rem;
  svg {
    margin-right: 0.8rem;
    color: #fff;
  }
`;

const Input = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  color: white;
  outline: none;
  font-size: 1rem;

  &::placeholder {
    color: #ddd;
  }
`;

const Button = styled.button`
  padding: 0.9rem;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #ff6a00, #ee0979);
  color: white;
  font-size: 1rem;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .spinner {
    width: 18px;
    height: 18px;
    border: 2px solid white;
    border-top: 2px solid transparent;
    border-radius: 50%;
    display: inline-block;
    animation: spin 0.6s linear infinite;
  }
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Error = styled.p`
  color: #ff4d4f;
  background: rgba(255, 77, 79, 0.1);
  font-size: 0.85rem;
  padding: 0.5rem;
  border-radius: 6px;
  text-align: left;
`;

const Success = styled.p`
  color: #4caf50;
  background: rgba(76, 175, 80, 0.1);
  font-size: 0.85rem;
  padding: 0.5rem;
  border-radius: 6px;
  text-align: left;
`;

const BackLink = styled.a`
  display: inline-block;
  margin-top: 1.5rem;
  color: #ffd369;
  font-size: 0.85rem;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
